import axios from 'axios';

import { DataQueue, GetBaseQueueOptions } from 'components/types';

import { DATA_QUEUE } from '../endpoints';

export const getDataQueue = ({ params, signal }: GetBaseQueueOptions) =>
  axios.get<DataQueue>(DATA_QUEUE, {
    signal,
    params
  });
